import './weather-card.styles.scss';

import moment from 'moment/moment';

const WeatherCard = ({ weatherData, arrNr }) => {
  const { dt_txt, main, weather } = weatherData.list[arrNr];
  const myStyle = {
    backgroundImage: `url(https://www.linkpicture.com/q/${weather[0].icon}.svg)`,
  };

  return (
    <div className='weather-card'>
      <p className='time'>{moment(dt_txt).format('hh:mm A')}</p>
      <div className='logo' style={myStyle}></div>
      <div className='min-max-temp'>
        <p className='min-temp'>{Math.round(main.temp_min)}/</p>
        <p className='max-temp'>{Math.round(main.temp_max)}</p>
      </div>
    </div>
  );
};

export default WeatherCard;
